import React, { useState, useEffect } from "react";
import Select from "react-select";
import { makeStyles } from "@material-ui/core/styles";
import RestService from "./../../Restservice";
import OptionAnanlysisTable from "./OptionAnanlysisTable";
import Loader from "../../component/Loader";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  setSelect: {
    width: "100%",
    display: "inline-block",
    marginLeft: "10px",
    marginBottom: "10px",
    marginTop: "10px",
  },
  blueBg: {
    backgroundColor: "#1b95e0",
  },
  icon: {
    float: "right",
    fontSize: "24px",
    cursor: "pointer",
    color: "#fff",
    fontWeight: "bold",
  },
  label: {
    color: "#fff",
    fontSize: "16px",
    fontWeight: "bold",
    paddingTop: "5px",
  },
}));

export default function OptionAnanlysis(props) {
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  const symbol = props?.symbol;
  const mobile = userdata.mobile ? userdata.mobile : "";
  const web_token = userdata.web_token ? userdata.web_token : "";
  const [option, setoption] = useState("Both");
  const [order, setOrder] = useState("DESC");
  const [expdate, setExpdate] = useState(false);
  const [keyname, setKeyName] = useState("contracts");
  const [results, setResults] = useState([]);
  const [ntime, setNtime] = useState(false);
  const [isshowData, setIsshowData] = useState(false);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (expdate && option) {
      setLoading(true);
      RestService.getBoardsDataBySymbol(
        function (res) {
          const response = JSON.parse(res);
          setResults({ ...results, [isshowData]: response.data?.results });
          if (!isshowData) setIsshowData(isshowData);
          setLoading(false);
        },
        symbol,
        mobile,
        web_token,
        expdate,
        option,
        order,
        keyname
      );
    }
  }, [symbol, mobile, web_token, expdate, option, ntime]);

  const getExpiryDate = (event) => {
    setExpdate(event.value);
    setResults([]);
    setIsshowData(false);
    setKeyName("contracts");
  };

  const handleClickEvent = (optionType) => {
    setoption(optionType);
    setResults([]);
    setIsshowData(false);
    setKeyName("contracts");
  };

  const handleEvent = (item) => {
    setIsshowData(isshowData === item?.value ? "" : item?.value);
    setOrder(item?.order);
    setKeyName(item?.keyname);
    var d = new Date();
    var n = d.getTime();
    if (!results?.[item?.value]) {
      setNtime(n);
    }
  };

  const optionArray = [
    {
      label: "Active By Contracts",
      keyname: "contracts",
      value: "contracts",
      order: "DESC",
      rowName: "Contracts",
    },
    {
      label: "Active By OI",
      keyname: "open_int",
      value: "open_int",
      order: "DESC",
      rowName: "OI",
    },
    {
      label: "Active By Price Change",
      keyname: "settle_price",
      value: "settle_price",
      order: "DESC",
      rowName: "Price Change",
    },
    {
      label: "Active By %Chg",
      keyname: "oiper",
      value: "oiperCHG",
      order: "DESC",
      rowName: "%Chg",
    },
    {
      label: "Active By Traded Value(Crs.)",
      keyname: "val_inlakh",
      value: "val_inlakh",
      order: "DESC",
      rowName: "Traded Value(Lakh.)",
    },
    {
      label: "Active By OI Gainer",
      keyname: "change_in_oi",
      value: "change_in_oiGainer",
      order: "DESC",
      rowName: "OI Gainer",
    },
    {
      label: "Active By OI% Loser",
      keyname: "oiper",
      value: "oiperASC",
      order: "ASC",
      rowName: "OI% Loser",
    },
    {
      label: "Active By OI Loser",
      keyname: "change_in_oi",
      value: "change_in_oi_loser",
      order: "ASC",
      rowName: "OI Loser",
    },
    {
      label: "Active By OI% Gainer",
      keyname: "oiper",
      value: "oiperGainer",
      order: "DESC",
      rowName: "OI% Gainer",
    },
  ];

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className={`${classes.blueBg} row  `}>
        <div className="col-sm-3">
          <h2 className="boldfont font-white mt-3">Option Analysis</h2>
        </div>
        <div className="col-sm-6 mt-2 text-right">
          <button
            onClick={(e) => handleClickEvent("Both")}
            className={
              option === "Both"
                ? "btn btn-success ml-1"
                : `btn btn-default ml-1`
            }
          >
            Both
          </button>
          <button
            onClick={(e) => handleClickEvent("CE")}
            className={
              option === "CE" ? "btn btn-success ml-1" : `btn btn-default ml-1`
            }
          >
            Call
          </button>
          <button
            onClick={(e) => handleClickEvent("PE")}
            className={
              option === "PE" ? "btn btn-success ml-1" : `btn btn-default ml-1`
            }
          >
            Put
          </button>
        </div>
        <div className="col-sm-3">
          {props.allDate && (
            <Select
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              menuPosition={"fixed"}
              onChange={getExpiryDate}
              options={props.allDate ? props.allDate : []}
              name="expiry_date"
              className={classes.setSelect + " select-option"}
            />
          )}
        </div>
      </div>
      {expdate &&
        optionArray.map((item, key) => (
          <div key={key} className="row mt-4">
            <div className={`${classes.blueBg} col-sm-12`}>
              <label className={classes.label}>{item?.label}</label>
              <div className={classes.icon}>
                <i
                  className={
                    isshowData === item?.value
                      ? "fa fa-angle-up"
                      : "fa fa-angle-down"
                  }
                  onClick={(e) => handleEvent(item)}
                ></i>
              </div>
            </div>

            <div className="col-sm-12 mt-2 p-0">
              {isshowData === item?.value && (
                <OptionAnanlysisTable
                  keyname={item?.value}
                  data={results?.[item?.value]}
                  rowName={item?.rowName}
                />
              )}
            </div>
          </div>
        ))}
    </>
  );
}
